var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fct-acronym"},[_c('span',[_vm._v(_vm._s(_vm.acronym))])])
}
var staticRenderFns = []

export { render, staticRenderFns }